module.exports = __webpack_public_path__ + "img/reduced_before_fer_2.d45d53fe.jpg";